import { useQuery } from "@tanstack/react-query";
import { getStoreOfAccountApiRequest } from "../../services";

export const useGetStoreOfAccountApi = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["all-store-of-account"],
    queryFn: () => getStoreOfAccountApiRequest(),
    enabled: true,
  });
  return {
    allStoreOfAccount: data,
    isLoading,
  };
};
